module.exports = __webpack_public_path__ + "static/rcc-orr-desktop-990db078bfb74eaa90209bbfa78f096c.png";